import styled from 'styled-components';

export const IpcXmlContactsStyles = styled.div`
max-width: 80%;
margin-left: 10%;
.mrd-contacts-container {
  .contact-group-type {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 40%;
    z-index: 99;

    .form-input-fields{
      min-width: 181px;
      display: table-cell;
      height: 32px;
    }
  }

.mrd-contact-button-container{
    padding-left: 40px;
    margin-bottom: -40px;
    padding-top: 10px;
    padding-bottom: 8px;
    position: relative;
    height: 30px;

    .mrd-contact-button {
      margin-right: 5px;
    }

  }

  .mrd-contact-table-container {
    justify-content: center;
    align-items: center;
    overflow: visible;

    .left-table {
      float: left;
      width: 20%;

      @media only screen and (max-width:1899px){
    .generated-list {
      padding-bottom: 15px !important;
    }
    .fkTuFL {
      max-height: 560px;
    }
  }
  @media only screen and (min-width:1900px) and (max-width:1915px){
    .generated-list {
      padding-bottom: 15px !important;
    }
    .fkTuFL {
      max-height: 660px;
    }
  }

  @media only screen and (min-width:1916px) and (max-width:2135px){
    .generated-list {
      padding-bottom: 15px !important;
    }
    .fkTuFL {
      max-height: 660px;
    }
  }

  @media only screen and (min-width:2136px) and (max-width:2200px){
    .generated-list {
      padding-bottom: 15px !important;
    }
    .fkTuFL {
      max-height: 753px;
    }
  }

  @media only screen and (min-width:2201px) and (max-width:2400px){
    .generated-list {
      padding-bottom: 15px !important;
    }
    .fkTuFL {
      max-height: 853px;
    }
  }

  @media only screen and (min-width:2401px) and (max-width:2800px){
    .generated-list {
      padding-bottom: 15px !important;
    }
    .fkTuFL {
      max-height: 953px;
    }
  }

  @media only screen and (min-width:2801px) and (max-width:2900px){
    .generated-list {
      padding-bottom: 15px !important;
    }
    .fkTuFL {
      max-height: 1053px;
    }
  }

  @media only screen and (min-width:2901px) and (max-width:3200px){
    .generated-list {
      padding-bottom: 15px !important;
    }
    .fkTuFL {
      max-height: 1153px;
    }
  }

  @media only screen and (min-width:3201px) and (max-width:3900px){
    .generated-list {
      padding-bottom: 15px !important;
    }
    .fkTuFL {
      max-height: 1453px;
    }
  }

  @media only screen and (min-width:3901px){
    .generated-list {
      padding-bottom: 15px !important;
    }
    .fkTuFL {
      max-height: 2200px;
    }
  }
    }
   .right-table {
    margin-top: -35px;
    float: left;
    width: 80%;
    .list-wrapper {
      margin-top: 35px;
    }

    .mrd-contact-right-button-container{
      padding-left: 40px;
      margin-bottom: -80px;
      padding-top: 10px;
      padding-bottom: 8px;
      position: relative;
      height: 30px;
      margin-top: 30px;

      .mrd-right-contact-button {
        margin-right: 5px;
      }
    }


    @media only screen and (max-width:1899px){
    .generated-list {
      padding-bottom: 15px !important;
    }
    .fkTuFL {
      max-height: 560px;
    }
  }
  @media only screen and (min-width:1900px) and (max-width:1915px){
    .generated-list {
      padding-bottom: 15px !important;
    }
    .fkTuFL {
      max-height: 660px;
    }
  }

  @media only screen and (min-width:1916px) and (max-width:2135px){
    .generated-list {
      padding-bottom: 15px !important;
    }
    .fkTuFL {
      max-height: 660px;
    }
  }

  @media only screen and (min-width:2136px) and (max-width:2200px){
    .generated-list {
      padding-bottom: 15px !important;
    }
    .fkTuFL {
      max-height: 753px;
    }
  }

  @media only screen and (min-width:2201px) and (max-width:2400px){
    .generated-list {
      padding-bottom: 15px !important;
    }
    .fkTuFL {
      max-height: 853px;
    }
  }

  @media only screen and (min-width:2401px) and (max-width:2800px){
    .generated-list {
      padding-bottom: 15px !important;
    }
    .fkTuFL {
      max-height: 953px;
    }
  }

  @media only screen and (min-width:2801px) and (max-width:2900px){
    .generated-list {
      padding-bottom: 15px !important;
    }
    .fkTuFL {
      max-height: 1053px;
    }
  }

  @media only screen and (min-width:2901px) and (max-width:3200px){
    .generated-list {
      padding-bottom: 15px !important;
    }
    .fkTuFL {
      max-height: 1153px;
    }
  }

  @media only screen and (min-width:3201px) and (max-width:3900px){
    .generated-list {
      padding-bottom: 15px !important;
    }
    .fkTuFL {
      max-height: 1453px;
    }
  }

  @media only screen and (min-width:3901px){
    .generated-list {
      padding-bottom: 15px !important;
    }
    .fkTuFL {
      max-height: 2200px;
    }
  }
   }
 }
}
`;
